function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 订单管理接口
 */
export default _defineProperty({
  // 内部采购企业-订单管理-货铺单位
  estore_completePebAfterService: {
    // mock: true,
    control: 'dyc/estore/order/peb/completePebAfterService'
  },
  // 订单详情查询(供应方)
  cnnc_querySupplierOrderDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/querySupplierOrderDetails'
  },
  // 电商 取消订单
  cnnc_extension_cancelOrder: {
    // mock: true,
    control: 'dyc/busicommon/order/cancelOrder'
  },
  // 用于维护客户的发运信息
  cnnc_saveAfterDeliveryInfo: {
    // mock: true,
    control: 'dyc/busicommon/order/saveAfterDeliveryInfo'
  },
  // 电商 到货验收
  estore_esOrderConfirm: {
    // mock: true,
    control: 'dyc/estore/order/esOrderConfirm'
  },
  // 内部采购企业-订单管理-货铺单位
  cnnc_queryGoodsSupplierforDrop: {
    // mock: true,
    control: 'dyc/supplier/queryGoodsSupplierforDrop'
  },
  // 内部采购企业-订单管理-采购单位
  cnnc_queryPurchaseAccount: {
    // mock: true,
    control: 'dyc/saas/common/user/org/qryPurchaseDropDwonList'
  },
  // 内部采购企业-订单管理-协议订单管理-我的订单-我的订单列表查询API
  cnnc_queryMyOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryMyOrderList'
  },
  // 内部采购企业-订单管理-协议订单管理-我的订单-我的订单列表查询API
  self_queryMyOrderList: {
    // mock: true,
    control: 'dyc/self/order/queryMyOrderList'
  },
  // 内部采购企业-订单管理-协议订单管理-我的订单-我的订单列表查询API
  cnnc_queryOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryOrderList'
  },
  // 内部采购企业-订单管理-协议订单管理-我的订单-我的待处理
  cnnc_queryPurchaseOrderListForPurchaser: {
    // mock: true,
    control: 'dyc/busicommon/order/queryPurchaseOrderListForPurchaser'
  },
  // 内部采购企业-订单管理-协议订单管理-我的订单-取消订单
  cnnc_cancelOrder: {
    // mock: true,
    control: 'dyc/busicommon/order/agr/cancelOrder'
  },
  // 内部采购企业-订单管理-协议订单管理-我的订单-取消订单详情
  cnnc_queryCancelApplyDetails: {
    // mock: true,
    control: 'dyc/estore/order/queryCancelApplyDetails'
  },
  // 内部采购企业-订单管理-协议订单管理-我的订单-撤销取消订单申请
  cnnc_approvalCancel: {
    // mock: true,
    control: 'dyc/busicommon/order/approvalCancel'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-订单分配-列表查询
  cnnc_queryOperatorOrderDistributionList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryOperatorOrderDistributionList'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-订单分配-分配专责查询
  cnnc_alreadyUsers: {
    // mock: true,
    control: 'dyc/saas/common/user/getAlreadyUsers'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-订单分配-确认订单分配
  cnnc_distOrder: {
    // mock: true,
    control: 'dyc/busicommon/order/distOrder'
  },
  // 内部采购企业-订单详情（销售订单）
  cnnc_QueryZoneOrderDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/queryZoneOrderDetails'
  },
  // 内部采购企业-订单详情(采购订单)
  cnnc_queryOperatorOrderDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/queryOperatorOrderDetails'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-我的待处理订单-订单调价核实详情
  cnnc_queryPurchaserPricingCheckDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/queryPurchaserPricingCheckDetails'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-我的待处理订单-订单调价核实详情(运营)
  cnnc_queryOperatorOrderReviewDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/queryOperatorOrderReviewDetails'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-我的待处理订单-订单调价核实
  cnnc_submitPricingCheck: {
    // mock: true,
    control: 'dyc/busicommon/order/submitPricingCheck'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-我的待处理订单-提醒供应商确认
  cnnc_remindSupplierConfirmation: {
    // mock: true,
    control: 'dyc/busicommon/order/remindSupplierConfirmation'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-我的待处理订单-催交
  cnnc_orderCall: {
    // mock: true,
    control: 'dyc/busicommon/order/orderCall'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-我的待处理订单-恢复订单
  cnnc_refusedOrder: {
    // mock: true,
    control: 'dyc/busicommon/order/refusedOrder'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-订单复核-订单复核列表
  cnnc_queryPurchaserOrderReviewList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryPurchaserOrderReviewList'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-订单复核-订单复核
  cnnc_reviewOrder: {
    // mock: true,
    control: 'dyc/busicommon/order/reviewOrder'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-我的取消申请 - 我的取消申请列表
  cnnc_queryMyCancelApplyList: {
    // mock: true,
    control: 'dyc/estore/order/queryMyCancelApplyList'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-订单审批-订单审批列表
  cnnc_queryApproveOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryApproveOrderList'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-订单审批-订单审批
  cnnc_approveOrder: {
    // mock: true,
    control: 'dyc/busicommon/order/approveOrder'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-收发货详情-整体进度
  cnnc_queryOrderOverallProgress: {
    // mock: true,
    control: 'dyc/busicommon/order/queryOrderOverallProgress'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-收发货详情-历史发货单
  cnnc_queryHisDeliveryOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryHisDeliveryOrderList'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-收发货详情-历史验收
  cnnc_queryHisAcceptOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryHisAcceptOrderList'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-收发货详情-历史售后
  cnnc_queryHisReturnOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryHisReturnOrderList'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-收发货详情-物流
  cnnc_esOrderLogisticsInfo: {
    // mock: true,
    control: 'dyc/estore/order/peb/esOrderLogisticsInfo'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-订单异常变更-列表查询
  cnnc_queryStayAbnormalChangeShipList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryStayAbnormalChangeShipList'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-订单异常变更-列表查询（电商）
  cnnc_queryEmcStayAbnormalChangeShipList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryEmcStayAbnormalChangeShipList'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-删除订单
  cnnc_deleteOrder: {
    // mock: true,
    control: 'dyc/busicommon/order/deleteOrder'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-	售后申请列表查询
  cnnc_queryAfterSaleApplyList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryAfterSaleApplyList'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-	超市售后申请详情查询
  cnnc_queryEstoreAfterSaleApplyDetails: {
    // mock: true,
    control: 'dyc/estore/order/queryEstoreAfterSaleApplyDetails'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-	待售后申请订单详情查询
  cnnc_queryNotAfterSaleApplyOrderDetail: {
    // mock: true,
    control: 'dyc/busicommon/order/queryNotAfterSaleApplyOrderDetail'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-	售后类型查询
  cnnc_qryAfterServiceType: {
    // mock: true,
    control: 'dyc/busicommon/order/qryAfterServiceType'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-	售后申请提交
  cnnc_submitAfterSaleApply: {
    // mock: true,
    control: 'dyc/busicommon/order/submitAfterSaleApply'
  },
  // 查询收货地址
  fsc_qryBuyAgainLogistics: {
    // mock: true,
    control: 'dyc/busicommon/order/qryBuyAgainLogistics'
  },
  // 商品所属频道查询
  m_queryChanneldepend: {
    // mock: true,
    control: 'dyc/mall/commodity/north/queryChanneldepend'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-加入购物车
  cnnc_addShoppingCart: {
    // mock: true,
    control: 'dyc/saas/common/user/addShoppingCart'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-待异常变更订单详情查询
  cnnc_queryStayAbnormalChangeOrderDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/queryStayAbnormalChangeOrderDetails'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-采购电商扩展订单异常变更提交
  cnnc_submitOrderAbnormalChanges: {
    // mock: true,
    control: 'dyc/busicommon/order/submitOrderAbnormalChanges'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-到货验收列表数据
  cnnc_queryArrivalAcceptList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryArrivalAcceptList'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-到货验收
  cnnc_allArrivalAccept: {
    // mock: true,
    control: 'dyc/busicommon/order/allArrivalAccept'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-到货验收详情
  cnnc_queryArrivalAcceptDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/queryArrivalAcceptDetails'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-订单审批流程日志列表
  cnnc_queryApprovalprocessListPage: {
    // mock: true,
    control: 'dyc/busicommon/order/queryApprovalprocessListPage'
  },
  // 订单计划配置
  cnnc_queryConfigByOrgId: {
    // mock: true,
    control: 'dyc/config/cfc/queryConfigByOrgId'
  },
  // 订单是否评价
  cnnc_whetherToEvaluate: {
    // mock: true,
    control: 'dyc/mall/order/whetherToEvaluate'
  },
  // 评价模板列表
  common_qryTemplateList: {
    // mock: true,
    control: 'dyc/busicommon/evaluate/qryTemplateList'
  },
  // 评价模板详情
  common_qryTemplateDetail: {
    // mock: true,
    control: 'dyc/busicommon/evaluate/qryTemplateDetail'
  },
  // 评价创建接口
  orderEvaluate: {
    // mock: true,
    control: 'dyc/busicommon/evaluate/evaluate'
  },
  // 查询评价详情
  uec_qryEvaluateDetail: {
    // mock: true,
    control: 'dyc/estore/evaluate/users/signup/qryEvaluateDetail'
  },
  // 电商订单-运营管理-评价管理-评价审批列表
  uec_qryEvaluateApprovalList: {
    // mock: true,
    control: 'dyc/busicommon/evaluate/qryEvaluateApprovalList'
  },
  // 电商订单-运营管理-评价管理-评价审批流程
  uec_qryUecApprovalprocessList: {
    // mock: true,
    control: 'dyc/common/qryUecApprovalprocessList'
  },
  // 电商订单-运营管理-评价管理-评价审批
  uec_dealEvaluateAudit: {
    // mock: true,
    control: '/dyc/busicommon/evaluate/dealEvaluateAudit'
  },
  // 供应商到货确认服务
  cnnc_confirmArrive: {
    // mock: true,
    control: 'dyc/busicommon/order/confirmArrive'
  },
  // 供应商到货拒收服务
  cnnc_rejectArrive: {
    // mock: true,
    control: 'dyc/busicommon/order/rejectArrive'
  },
  // 内部采购企业-订单管理-ZMY-协议订单管理-售后管理
  cnnc_queryNotAfterSaleApplyOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryNotAfterSaleApplyOrderList'
  },
  // 协议订单采购单位取消售后申请
  cnnc_CancelAgreementOrderAfterSale: {
    // mock: true,
    control: 'dyc/busicommon/order/cancelAgreementOrderAfterSale'
  },
  // 协议订单采购单位取消售后申请
  cnnc_completeAfterService: {
    // mock: true,
    control: 'dyc/busicommon/order/completeAfterService'
  },
  // 协议订单采购单位取消售后申请(shopPendingOrder)
  cnnc_supCompleteAfterService: {
    // mock: true,
    control: 'dyc/busicommon/order/supCompleteAfterService'
  },
  // 订单复核列表查询（运营方）
  cnnc_queryOperatorOrderReviewList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryOperatorOrderReviewList'
  },
  // 异常变更订单审批列表查询（运营方）
  cnnc_queryAbnormalChangeOrderApprovalList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryAbnormalChangeOrderApprovalList'
  },
  // 采购电商扩展订单异常变更审批
  cnnc_approvalOrderAbnormalChanges: {
    // mock: true,
    control: 'dyc/busicommon/order/approvalOrderAbnormalChanges'
  },
  // 订单完成订单验收查询
  cnnc_queryAcceptDetail: {
    // mock: true,
    control: 'dyc/busicommon/order/queryAcceptDetail'
  },
  // 打印验收单
  cnnc_printAcceptOrder: {
    // mock: true,
    control: 'dyc/busicommon/order/printAcceptOrder'
  },
  // 导出打印
  cnnc_exportPrintOrderDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/exportPrintOrderDetails'
  },
  // 用于验收单导出
  cnnc_exportInspectionDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/exportInspectionDetails'
  },
  // 打印发货单
  common_taskCommit: {
    // mock: true,
    control: 'dyc/saas/common/communal/download/fileGeneration/taskCommit'
  },
  // 导出功能调用接口
  commodity_importSkuStockDetailsTemplate: {
    // mock: true,
    control: 'dyc/busicommon/commodity/importSkuStockDetailsTemplate'
  },
  // 协议订单供应厂商查询
  order_querySupplier: {
    // mock: true,
    control: 'dyc/saas/common/user/enterprise/qryDropDwonList'
  },
  // 协议订单供应厂商查询
  order_queryMerchantList: {
    // mock: true,
    control: 'dyc/saas/common/user/mem/queryMerchantList'
  },
  // 协议订单采购单位查询
  order_queryPurchaseAccount: {
    // mock: true,
    control: 'dyc/common/user/account/queryPurchaseAccount'
  },
  // 协议订单采购单位搜后记录查询
  order_queryAfterSaleRecordList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryAfterSaleRecordList'
  },
  // 协议订单采购单位售后服务单查询
  order_queryZoneAfterSaleApplyDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/queryZoneAfterSaleApplyDetails'
  },
  // 协议订单采购单位铺货单位
  order_queryGoodsSupplierforDrop: {
    // mock: true,
    control: 'dyc/supplier/queryGoodsSupplierforDrop'
  },
  // 运营单位-订单管理-协议订单管理-我的采购订单列表查询
  order_queryPurchaseOrderListForPurchaser: {
    // mock: true,
    control: 'dyc/busicommon/order/queryPurchaseOrderListForPurchaser'
  },
  // 运营单位-订单管理-协议订单管理-我的采购订单列表查询
  order_queryMySaleOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryMySaleOrderList'
  },
  // 运营单位-订单管理-协议订单统计查询-采购订单查询列表
  order_queryOperatorPurchaseOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryOperatorPurchaseOrderList'
  },
  // 运营单位-订单管理-协议订单统计查询-销售订单查询列表
  order_querySaleOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/querySaleOrderList'
  },
  // 运营单位-订单管理-协议订单统计查询-订单调价查询-订单调价查询列表
  order_queryOperatorOrderPricingList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryOperatorOrderPricingList'
  },
  // 运营单位-订单管理-协议订单统计查询-订单调价查询-查看调价详情
  order_queryOperatorOrderPricingDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/queryOperatorOrderPricingDetails'
  },
  // 订单管理/协议订单统计查询/订单异常变更查询/订单异常变更查询
  order_queryAbnormalChangeOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryAbnormalChangeOrderList'
  },
  // 订单管理/协议订单统计查询/订单异常变更查询/订单异常变更详情查询
  order_queryAbnormalChangeOrderDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/queryAbnormalChangeOrderDetails'
  },
  // 供应商/订单管理 /商城订单管理 /我的商城订单 / 我的商城订单列表 / 待确认
  order_queryAgreementOrderList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryAgreementOrderList'
  },
  // 供应商/订单管理 /商城订单管理 /我的商城订单 / 我的商城订单列表 / 供应商确认
  order_supplierConfirm: {
    // mock: true,
    control: 'dyc/busicommon/order/supplierConfirm'
  },
  // 供应商/订单管理 /商城订单管理 /我的商城订单 / 我的商城订单列表 / 供应商拒单
  order_supplierRefused: {
    // mock: true,
    control: 'dyc/busicommon/order/supplierRefused'
  },
  // 供应商/订单管理 /商城订单管理 /我的商城订单 / 我的商城订单列表 / 订单发货
  order_deliverGoods: {
    // mock: true,
    control: 'dyc/busicommon/order/deliverGoods'
  },
  // 供应商/订单管理 /商城订单管理 /我的商城订单 / 我的商城订单列表 / 到货登记
  order_arrivalRegister: {
    // mock: true,
    control: 'dyc/busicommon/order/arrivalRegister'
  },
  // 供应商/订单管理 /商城订单管理 /我的商城订单 / 我的商城订单列表 / 取消订单申请
  order_approvalCancelList: {
    // mock: true,
    control: 'dyc/busicommon/order/approvalCancelList'
  },
  // 供应商/订单管理 /商城订单管理 /我的商城订单 / 我的商城订单列表 / 售后申请
  order_queryAgreementOrderAfterSaleList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryAgreementOrderAfterSaleList'
  },
  // 供应商/订单管理 /商城订单管理 /我的商城订单 / 我的商城订单列表 / 异常订单变更审批列表查询
  order_queryAbnormalChangeOrderApprovalList: {
    // mock: true,
    control: 'dyc/busicommon/order/queryAbnormalChangeOrderApprovalList'
  },
  // 供应商/订单管理 /商城订单管理 /我的商城订单 / 我的商城订单列表 / 售后申请确认
  order_confirmAgreementOrderAfterSale: {
    // mock: true,
    control: 'dyc/busicommon/order/confirmAgreementOrderAfterSale'
  },
  // 运营单位 / 1menu订单管理 / 2menu协议订单管理 / 3menu我的三方交易销售订单 / 我的三方交易销售订单-核实中 / 调价核实
  cnnc_queryOperatorPricingCheckDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/queryOperatorPricingCheckDetails'
  },
  // 查询订单详情
  cnnc_queryEstoreOrderDetails: {
    // mock: true,
    control: 'dyc/busicommon/order/queryEstoreOrderDetails'
  },
  // 订单支付
  dyc_dealPayBillCreateAndPay: {
    // mock: true,
    control: 'dyc/fsc/dealPayBillCreateAndPay'
  },
  // 订单支付
  dyc_new_dealPayBillCreateAndPay: {
    // mock: true,
    control: 'dyc/saas/self/noauth/order/qrySalOrderDetail'
  },
  // 合同下单列表
  dyc_costContractList: {
    // mock: true,
    control: 'dyc/zone/commodity/costContractList'
  },
  // 合同下单查询商品信息列表
  dyc_costContractDetailList: {
    // mock: true,
    control: 'dyc/zone/commodity/costContractDetailList'
  },
  // 退款申请列表
  dyc_qryRefundList: {
    // mock: true,
    control: 'dyc/fsc/refund/qryRefundList'
  },
  // 退款查询列表
  dyc_qryRefundCountList: {
    // mock: true,
    control: 'dyc/fsc/refund/qryRefundCountList'
  },
  // 退款
  dyc_dealRefund: {
    // mock: true,
    control: 'dyc/fsc/dealRefund'
  },
  // 快速下单列表
  dyc_quickOrderList: {
    // mock: true,
    control: 'dyc/saas/self/order/quickOrderList'
  },
  // 快速下单查询采购单位
  dyc_quickQryEnterpriseInfoListPage: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/qryEnterpriseInfoListPage'
  },
  // 快速下单删除
  dyc_delQuickOrder: {
    // mock: true,
    control: 'dyc/saas/self/order/delQuickOrder'
  },
  // 快速下单订单详情
  dyc_quickOrderDetails: {
    // mock: true,
    control: 'dyc/saas/self/order/qryQuickOrderDetails'
  },
  // 快速下单地址获取经纬度
  dyc_quickAddressGeocoding: {
    // mock: true,
    control: 'dyc/saas/common/user/getAddressGeocoding'
  },
  // 快速下单保存
  dyc_saveQuickOrder: {
    // mock: true,
    control: 'dyc/saas/self/order/saveQuickOrder'
  },
  // 快速下单导入
  dyc_quickOrderImport: {
    // mock: true,
    control: '	dyc/saas/self/order/quickOrderImport'
  },
  // 根据下单人获取地址信息
  dyc_getQuickOrderLogisticsRela: {
    // mock: true,
    control: 'dyc/saas/common/getQuickOrderLogisticsRela'
  },
  // 根据下单人获取地址信息
  dyc_qryOrderSalOrderList: {
    // mock: true,
    control: 'dyc/saas/self/order/qrySalOrderList'
  },
  // 获取收银台url
  dyc_dealSaasPayBillCreateAndPay: {
    // mock: true,
    control: 'dyc/saas/self/order/dealPayBillCreateAndPay'
  },
  // 查询品牌下拉框列表
  dyc_dealQryBrandList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/noauth/qryBrandList'
  },
  // 查询付款条件
  dyc_qryCreditAccountPeriodInfo: {
    // mock: true,
    control: 'dyc/saas/common/credit/qryCreditAccountPeriodInfo'
  },
  //  分单查询
  meta_qrySalOrderDetail_0001: {
    control: "dyc/saas/self/order/querySaleOrderDetail"
  },
  //  供应商查询
  meta_qryContractOrgList_0002: {
    control: "metaData/liandongMember/dycUmcContractSupplierOrgListQryService/auto0002/qryContractOrgList"
  },
  // 分类查询
  meta_listTree_0001: {
    control: "metaData/liandongMember/dycUccMdmCatalogListTreeAbilityService/auto0001/listTree"
  },
  meta_saveSaleReinsurancePolicyList_0001: {
    control: "metaData/liandongOrder/ldUocSaveSaleReinsurancePolicyListService/auto0001/saveSaleReinsurancePolicyList"
  },
  // 分单导入文件解析
  meta_quickOrderSaveImport_0001: {
    control: "metaData/liandongOrder/ldUocQuickOrderSaveImportService/auto0001/quickOrderSaveImport"
  }
}, "meta_quickOrderSaveImport_0001", {
  control: "metaData/liandongOrder/ldUocQuickOrderSaveImportService/auto0001/quickOrderSaveImport"
});